import { render } from "./numerator.vue?vue&type=template&id=40997b2b&scoped=true"
import script from "./numerator.vue?vue&type=script&lang=js"
export * from "./numerator.vue?vue&type=script&lang=js"

import "./numerator.vue?vue&type=style&index=0&id=40997b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40997b2b"]])

export default __exports__